import { withDatasourceCheck } from '@sitecore-jss/sitecore-jss-nextjs';
import { sanitize } from 'isomorphic-dompurify';

import { QueryParamsFields, useShouldRenderForQueryParam } from '@gn-audio/jss-components';

import { useSpotTracking } from 'utils/hooks/useSpotTracking';

import CategoryPromoSlider from './CategoryPromoSlider';
import { CategoryPromoSpotFields } from './categoryPromoSpotTypes';

const CategoryPromoSpot = ({ fields }: { fields: CategoryPromoSpotFields & QueryParamsFields }) => {
  const {
    title,
    description,
    categoryPromoItems,
    queryParamKey,
    queryParamValue,
    queryParamAction,
  } = fields;
  const spotRef = useSpotTracking(fields.trackingSpotName?.value);
  const shouldRender = useShouldRenderForQueryParam({
    queryParamKey,
    queryParamValue,
    queryParamAction,
  });
  if (!shouldRender) return null;
  return (
    <div
      ref={spotRef}
      data-wt-spot={fields.trackingSpotName?.value}
      className="container-fluid flex w-full flex-col overflow-hidden"
    >
      <div className="mx-auto mb-8 max-w-5xl text-center">
        <h2 className="heading-2" dangerouslySetInnerHTML={{ __html: sanitize(title?.value) }} />
        {!!description.value && (
          <p
            className="paragraph-large mb-6"
            dangerouslySetInnerHTML={{ __html: sanitize(description?.value as string) }}
          />
        )}
      </div>
      <CategoryPromoSlider items={categoryPromoItems} />
    </div>
  );
};

export default withDatasourceCheck()(CategoryPromoSpot as any);
